import { useAuth0 } from '@auth0/auth0-react'
import { useTranslations } from 'next-intl'
import React from 'react'
import Button from '@/components/ui/button'

interface Props {
  className?: string
}

const LoginButton = ({ className = '' }: Props) => {
  const t = useTranslations()
  const { loginWithRedirect } = useAuth0()

  const login = async () => {
    loginWithRedirect().then((response) => {
      return response
    })
  }

  return (
    <Button onClick={() => login()} className={className} testId="login-button">
      {t('Auth-logIn')}
    </Button>
  )
}

export default LoginButton
